/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ModerationDropdownContainer_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"ModerationActionsContainer_viewer">;
    readonly " $refType": "ModerationDropdownContainer_viewer";
};
export type ModerationDropdownContainer_viewer$data = ModerationDropdownContainer_viewer;
export type ModerationDropdownContainer_viewer$key = {
    readonly " $data"?: ModerationDropdownContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerationDropdownContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerationDropdownContainer_viewer",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ModerationActionsContainer_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '814d14dee62e356bd934c3a20ae63c70';
export default node;
